<div class="main-content">
  <section class="access">
    <div class="container">
      <div class="row">
        <div class="col-md-12 col-xs-12">
          <ul class="step">
            <li class="active"><span>店舗選択</span></li>
            <li><span>基本情報等の入力</span></li>
            <li><span>入力内容確認</span></li>
            <li><span>お申し込み完了</span></li>
          </ul>
          <div class="clearfix"></div>
          <h2 class="title">店舗選択</h2>
          <p>店舗を選択してください。</p>
          <div class="clearfix"></div>
          <form novalidate (ngSubmit)="next()">
            <div class="application">
              <div class="application-row-step1">
                <div id="contentsBox">
                  <nav id="areaNav">
                    <p class="areaNav_caption"></p>
                    <p aria-hidden="true"></p>
                    <p class="area_pc"><img src="img/shopmap.png" alt="店舗エリアの地図"></p>
                    <ul>
                      <li id="hokkaido_btn" class="map-btn-font">
                        <a (click)="scrollToSection('hokkaido', $event)"><i class="fas fa-arrow-alt-circle-right"></i>北海道</a>
                      </li>
                      <li id="touhoku_btn" class="map-btn-font">
                        <a (click)="scrollToSection('touhoku', $event)"><i class="fas fa-arrow-alt-circle-right"></i>東北</a>
                      </li>
                      <li id="kantou_btn" class="map-btn-font" (mouseenter)="showTokyoSub=true" (mouseleave)="showTokyoSub=false">
                        <a (click)="scrollToSection('kantou', $event)"><i class="fas fa-arrow-alt-circle-right"></i>関東</a>
                        <ul class="tokyo_sub" [style.display]="showTokyoSub ? 'block' : 'none'">
                          <li id="tokyo23_btn" class="tokyo_sub_item"><a (click)="scrollToSection('tokyo23', $event, 'kantou')">東京23区</a></li>
                          <li id="tokyotoka_btn" class="tokyo_sub_item"><a (click)="scrollToSection('tokyotoka', $event, 'kantou')">東京都下</a></li>
                          <li id="kanagawa_btn" class="tokyo_sub_item"><a (click)="scrollToSection('kanagawa', $event, 'kantou')">神奈川</a></li>
                          <li id="saitama_btn" class="tokyo_sub_item"><a (click)="scrollToSection('saitama', $event, 'kantou')">埼玉</a></li>
                          <li id="chiba_btn" class="tokyo_sub_item"><a (click)="scrollToSection('chiba', $event, 'kantou')">千葉</a></li>
                          <li id="ibaraki_btn" class="tokyo_sub_item"><a (click)="scrollToSection('ibaraki', $event, 'kantou')">茨城</a></li>
                          <li id="gunma_btn" class="tokyo_sub_item"><a (click)="scrollToSection('gunma', $event, 'kantou')">群馬</a></li>
                          <li id="tochigi_btn" class="tokyo_sub_item"><a (click)="scrollToSection('tochigi', $event, 'kantou')">栃木</a></li>
                        </ul>
                      </li>
                      <li id="chubu_btn" class="map-btn-font">
                        <a (click)="scrollToSection('chubu', $event)"><i class="fas fa-arrow-alt-circle-right"></i>中部</a>
                      </li>
                      <li id="kinki_btn" class="map-btn-font">
                        <a (click)="scrollToSection('kinki', $event)"><i class="fas fa-arrow-alt-circle-right"></i>近畿</a>
                      </li>
                      <li id="chugoku_btn" class="map-btn-font">
                        <a (click)="scrollToSection('chugoku', $event)"><i class="fas fa-arrow-alt-circle-right"></i>中国</a>
                      </li>
                      <li id="shikoku_btn" class="map-btn-font">
                        <a (click)="scrollToSection('shikoku', $event)"><i class="fas fa-arrow-alt-circle-right"></i>四国</a>
                      </li>
                      <li id="kyushu_btn" class="map-btn-font">
                        <a (click)="scrollToSection('kyushu', $event)"><i class="fas fa-arrow-alt-circle-right"></i>九州</a>
                      </li>
                      <li id="okinawa_btn" class="map-btn-font">
                        <a (click)="scrollToSection('okinawa', $event)"><i class="fas fa-arrow-alt-circle-right"></i>沖縄</a>
                      </li>
                    </ul>
                    <div class="clearfix"></div>
                  </nav>

                  <!-- 店舗アコーディオン -->
                  @for (local of locals; track local.localNumber) {
                    @if (local.localNumber % 100 === 0) {
                      <section [id]="local.idName" [attr.name]="local.idName">
                        <header class="subTit content_trigger" (click)="toggleSection(local.idName)" [class.current]="openSections[local.idName]">
                          <div class="subTit_inner">
                            <h1 class="map-btn-font"><b>{{local.name}}</b></h1>
                          </div>
                        </header>
                        @if (openSections[local.idName]) {
                          @if (local.localNumber !== 300 && studioDisplay(local, studios)) {
                            <div class="content_accordion" @accordionSlide>
                              <div class="container-fluid">
                                <div class="row">
                                  <div class="col-xs-6 col-md-3 shop_list_title">店舗名</div>
                                  <div class="col-xs-6 col-md-3 shop_list_title">電話番号</div>
                                  <div class="col-xs-12 col-md-6 shop_list_title">住所</div>
                                </div>
                                @for (studio of studios; track studio.id) {
                                  @if (studioDisplay(local, studio.localNumber)) {
                                    <div class="row shop_list_row-height">
                                      <div class="col-xs-6 col-md-3 shop_list_contents">
                                        <button type="submit" class="btn-select_studio" (click)="studioClick(studio.id, studio.name)">{{studio.name}}</button>
                                      </div>
                                      <div class="col-xs-6 col-md-3 shop_list_contents">{{studio.phone}}</div>
                                      <div class="col-xs-12 col-md-6 shop_list_contents">{{studio.province}}{{studio.city}}{{studio.area}}{{studio.address}}</div>
                                    </div>
                                  }
                                }
                              </div>
                            </div>
                          }
                          @if (local.localNumber === 300) {
                            <div class="content_accordion" @accordionSlide>
                              @for (cLocal of locals; track cLocal.localNumber) {
                                @if (cLocal.localNumber % local.localNumber < 99 && cLocal.localNumber % 100 !== 0) {
                                  <section class="childCatSct" [id]="cLocal.idName">
                                    <p class="childCatLine"></p>
                                    <h2 class="childCatName content_trigger" (click)="toggleSection(cLocal.idName)" [class.current]="openSections[cLocal.idName]">
                                      <span>【{{cLocal.name}}】</span>
                                    </h2>
                                    @if (openSections[cLocal.idName] && studioDisplay(cLocal, studios)) {
                                      <div class="content_accordion" @accordionSlide>
                                        <div class="container-fluid">
                                          <div class="row">
                                            <div class="col-xs-6 col-md-3 shop_list_title">店舗名</div>
                                            <div class="col-xs-6 col-md-3 shop_list_title">電話番号</div>
                                            <div class="col-xs-12 col-md-6 shop_list_title">住所</div>
                                          </div>
                                          @for (studio of studios; track studio.id) {
                                            @if (studioDisplay(cLocal, studio.localNumber)) {
                                              <div class="row shop_list_row-height">
                                                <div class="col-xs-6 col-md-3 shop_list_contents">
                                                  <button type="submit" class="btn-select_studio" (click)="studioClick(studio.id, studio.name)">{{studio.name}}</button>
                                                </div>
                                                <div class="col-xs-6 col-md-3 shop_list_contents">{{studio.phone}}</div>
                                                <div class="col-xs-12 col-md-6 shop_list_contents">{{studio.province}}{{studio.city}}{{studio.area}}{{studio.address}}</div>
                                              </div>
                                            }
                                          }
                                        </div>
                                      </div>
                                    }
                                  </section>
                                }
                              }
                            </div>
                          }
                        }
                      </section>
                    }
                  }
                </div>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </section>
</div>
